// extracted by mini-css-extract-plugin
export default {"fullScreen":"FullScreen_fullScreen__3OgJW","imageBackground":"FullScreen_imageBackground__ZXfsp","colorBackground":"FullScreen_colorBackground__a5Hi1"};